var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tenant-project-tech-comment",
      attrs: { id: "tenant-project-tech-comment" },
    },
    [
      _c("div", { staticClass: "title-area clearfix" }, [
        _c("div", { staticClass: "guideline-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t("tenantProjects.submission.comment.technicalReview")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "records" }, [
          _vm.lastTechCommentActionText && (_vm.isPic || _vm.isSubmitted)
            ? _c("span", { staticClass: "update-history__upper-text" }, [
                !_vm.isPic
                  ? _c("span", { staticClass: "font-gray" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.underReviewText) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.lastTechCommentActionText && (_vm.isPic || _vm.isSubmitted)
            ? _c("div", { staticClass: "update-history__upper-text" }, [
                _c("span", { staticClass: "font-gray" }, [
                  _vm._v(_vm._s(_vm.lastTechCommentActionText)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isStarted
            ? _c("i", { staticClass: "font-gray" }, [
                _vm._v("\n        " + _vm._s(_vm.reviewStartedOn) + "\n      "),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      !_vm.isStarted
        ? _c("div", [
            _vm.isShowFitoutCommentBtn || _vm.isShowReinstatementCommentBtn
              ? _c("div", { staticClass: "start-btn-wrapper" }, [
                  _c(
                    "button",
                    {
                      staticClass: "start-btn btn--darkblue",
                      on: { click: _vm.startTechReview },
                    },
                    [
                      _vm.isShowReinstatementCommentBtn
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("action.startReview"))),
                          ])
                        : !_vm.isDesignCommentDisapproved
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.deep(_vm.activeSubmission, "designComment")
                                  ? _vm.$t("action.comment")
                                  : _vm.$t("action.startReview")
                              )
                            ),
                          ])
                        : _c("span", [_vm._v(_vm._s(_vm.$t("action.edit")))]),
                    ]
                  ),
                ])
              : _c("div", [
                  _c("p", { staticClass: "tech-comment-not-started" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "tenantProjects.submission.comment.techNotStarted"
                          )
                        ) +
                        ".\n      "
                    ),
                  ]),
                ]),
          ])
        : _c("div", [
            !_vm.isPic && !_vm.isSubmitted && !_vm.isAllowablePM
              ? _c("div", { staticClass: "under-review-hint__text" }, [
                  _vm._v("\n      " + _vm._s(_vm.underReviewText) + "\n    "),
                ])
              : _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "closing margin-bottom" },
                      [
                        _vm.canEditingEditor
                          ? _c("DescriptionTinymceEditor", {
                              key: _vm.activeSubmission.id + "_greetingEditor",
                              ref: "greetingEditor",
                              staticClass: "margin-bottom",
                              attrs: {
                                contentStyle: _vm.editorContentStyle,
                                height: 300,
                              },
                              model: {
                                value: _vm.greetingDescription,
                                callback: function ($$v) {
                                  _vm.greetingDescription = $$v
                                },
                                expression: "greetingDescription",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.canEdit
                      ? _c("p", {
                          staticClass: "design-comment-text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.techComment.greetingDescription
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "closing margin-bottom" },
                      [
                        _vm.canEditingEditor
                          ? _c("DescriptionTinymceEditor", {
                              key: _vm.activeSubmission.id,
                              ref: "descriptionEditor",
                              staticClass: "comment-text",
                              attrs: {
                                contentStyle: _vm.editorContentStyle,
                                height: 200,
                              },
                              model: {
                                value: _vm.description,
                                callback: function ($$v) {
                                  _vm.description = $$v
                                },
                                expression: "description",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.canEdit
                      ? _c("p", {
                          staticClass: "design-comment-text",
                          domProps: {
                            innerHTML: _vm._s(_vm.techComment.description),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("TechCommentsGuidelines"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "closing margin-bottom" },
                      [
                        _vm.canEditingEditor
                          ? _c("DescriptionTinymceEditor", {
                              key: _vm.activeSubmission.id,
                              ref: "closingEditor",
                              attrs: {
                                contentStyle: _vm.editorContentStyle,
                                height: 300,
                              },
                              model: {
                                value: _vm.closingDescription,
                                callback: function ($$v) {
                                  _vm.closingDescription = $$v
                                },
                                expression: "closingDescription",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.canEdit
                      ? _c("p", {
                          staticClass: "design-comment-text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.techComment.closingDescription
                            ),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }